/**
 * mwApp.services module <br>
 * Work with services: show/add/edit/remove
 *
 * @namespace mwApp/services
 */

import servicesConfig from './services.config'
import CatchupCtrl from './catchups.controller'
import AddCatchupCtrl from './addCatchUp.controller'
import LiveRewindCtrl from './liveRewinds.controller'
import AddLiveRewindCtrl from './addLiveRewind.controller'
import AddEpgCtrl from './addEpg.controller'
import EpgCtrl from './epgs.controller'

export default
angular.module('mwApp/services', [])
  .config(servicesConfig)
  .controller('CatchupCtrl', CatchupCtrl)
  .controller('AddCatchupCtrl', AddCatchupCtrl)
  .controller('LiveRewindCtrl', LiveRewindCtrl)
  .controller('AddLiveRewindCtrl', AddLiveRewindCtrl)
  .controller('EpgCtrl', EpgCtrl)
  .controller('AddEpgCtrl', AddEpgCtrl)
